import React from "react";
import { CheckCircle, X } from "lucide-react";

export default function UploadSuccessPopup({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 backdrop-blur-sm">

      {/* POPUP BOX */}
      <div className="relative bg-white w-[90%] max-w-sm rounded-2xl shadow-2xl p-6 text-center animate-fadeIn">

        {/* CLOSE */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-red-500"
        >
          <X size={18} />
        </button>

        {/* ICON */}
        <div className="flex justify-center mb-4">
          <CheckCircle size={60} className="text-green-500" />
        </div>

        {/* TITLE */}
        <h2 className="text-xl font-bold text-gray-800">
          Upload Successful 🎉
        </h2>

        {/* MESSAGE */}
       <p className="text-sm text-gray-500 mt-2">
  Your prescription has been uploaded successfully.
</p>

<div className="mt-3 bg-green-50 text-green-700 text-xs px-3 py-2 rounded-lg">
  ⏳ Our team will connect with you within 12 hours
</div>

        {/* BUTTON */}
        <button
          onClick={onClose}
          className="mt-6 w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white py-2.5 rounded-xl font-semibold shadow-md hover:scale-[1.03] transition"
        >
          Done
        </button>

      </div>
    </div>
  );
}